const routes = [
  {
    path: '/transfers',
    component: () => import('src/layouts/MainLayout.vue'),
    children: [
      {
        path: '/transfersbuscar',
        name: 'TransfersBuscar',
        component: () => import('src/pages/TransfersBuscar.vue')
      },

      {
        path: '/transfersreservar',
        name: 'transfersReservar',
        component: () => import('src/pages/TransfersReservar.vue')
      },

      {
        path: '/reserva',
        name: 'reservaVista',
        component: () => import('src/pages/Reserva.vue')
      },

      // Pagos
      {
        path: '/transferspago',
        name: 'transfersPago',
        component: () => import('src/pages/TransfersPago.vue')
      },
      {
        path: '/pagocancelado',
        name: 'pagocancelado',
        component: () => import('src/pages/PagoCancelado.vue')
      } /*,
      {
        path: '/pagoexitoso',
        name: 'pagoexitoso',
        component: () => import('src/pages/PagoExitoso.vue')
      } */
    ]
  },

  // Always leave this as last one, but you can also remove it
  {
    path: '/:catchAll(.*)*',
    name: 'errorpage',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
